import { StyleSheet, Text, View, Image, TouchableOpacity, Animated } from 'react-native'
import { Bank } from '../types/bankVerify';
import { ThemedText, ThemedView } from '@app/theme';
import RadioV2 from '@app/sharedComponents/RadioV2/RadioV2';
import { useRef, useState } from 'react';
import { useEffect } from 'react';
import { trackEvent } from '@app/utils/amplitude';


const BankSelectionCard = ({ bank, isSelected, onSelect }: { bank: Bank, isSelected: boolean, onSelect: (bank: Bank) => void }) => {

  const opacity = useRef(new Animated.Value(0)).current;

  const [logo, setLogo] = useState<string>(`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${bank.ifscCode.substring(0, 4)}.png`)

  useEffect(() => {
    Animated.timing(opacity, {
      toValue: 1,
      duration: 500,
      useNativeDriver: true,
    }).start();
  }, []);
  return (
    <Animated.View style={{ opacity }}>
      <TouchableOpacity onPress={() => {
        trackEvent('BANK_ACCOUNT_VERIFICATION_BANK_SELECTED')
        onSelect(bank)
      }}
      >
        <ThemedView padding='md' flexDirection='row' borderWidth={1} bg={isSelected ? 'bg-fill-emphasis-primary-1' : 'bg-surface-primary'} borderColor={isSelected ? 'bg-action-primary' : 'border-primary'} mb='lg' borderRadius='xs' alignItems='center'>
          <RadioV2 isSelected={isSelected} />
          <ThemedView justifyContent='space-between' flex={1} ml='md' flexDirection='row'>
            <ThemedView>
              <ThemedText variant='b3r' color='text-secondary'>{bank.bankName}</ThemedText>
              <ThemedText variant='b2s' mt='xs' color='text-primary'>XXXX {bank.accountNumber.slice(-4)}</ThemedText>
            </ThemedView>
            <Image source={{ uri: logo }} onError={() => {
              setLogo(`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/default.png`)
            }} style={{ width: 40, height: 40 }} />
          </ThemedView>
        </ThemedView>
      </TouchableOpacity>
    </Animated.View>
  )
}

export default BankSelectionCard

const styles = StyleSheet.create({})